import type { FallbackProps } from 'react-error-boundary';

const isErrorWithMessage = (error: FallbackProps['error']): error is { message: string } => {
  return typeof error === 'object' && error !== null && 'message' in error;
};

export { isErrorWithMessage };
